var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-list-row"},[_c('div',{staticClass:"block-list-row__left flex align-center justify-start gap"},[_vm._t("default")],2),_c('div',{staticClass:"block-list-row__right"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }